import Sidebar from "../../../Components/Sidebar/Sidebar";
import SidebarGroup from "../../../Components/Sidebar/SidebarGroup";
import SidebarButton from "../../../Components/Sidebar/SidebarButton";
import { useHistory } from "react-router";
import { Vehicle, VehicleAssessment } from "../../../system/Domain";
import useUser from "../../../system/useUser";
import { UserRole } from "../../../system/Domain";
import { useState } from "react";
import ManualDatValuationDialog from "./ManualDatValuationDialog";

interface Props {
	vehicle: Vehicle

	canAddToRemarketing: boolean
	handleAddToRemarketing: () => void

	canWithdrawRejection: boolean
	handleWithdrawRejection: () => void

	canReject: boolean
	handleRejection: () => void

	vehicleAssessment: VehicleAssessment
	setVehicleAssessment: (assessment: VehicleAssessment) => void
}

const AssessmentPageSidebar = (props:Props) => {
	const history = useHistory();
	const [, , hasRole] = useUser();
	const [manualDatDialogOpen, setManualDatDialogOpen] = useState(false);

	const handleShowAll = () => {
		history.push(`/vehicles/${props.vehicle!.id}/assessments`);
	};

	return (
		<Sidebar>
			<SidebarGroup>
				<SidebarButton
					label="Übersicht"
					color="primary"
					onClick={handleShowAll}
				/>
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton
					label="Beim Provider ablehnen"
					disabled={!props.canReject}
					onClick={props.handleRejection}
					color="secondary"
				/>
				{props.canWithdrawRejection && (
					<SidebarButton
						label="Ablehnung widerrufen"
						onClick={props.handleWithdrawRejection}
						color="secondary"
					/>
				)}
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton
					label="In der Validierung verwenden"
					disabled={!props.canAddToRemarketing}
					onClick={props.handleAddToRemarketing}
				/>
			</SidebarGroup>
			{hasRole(UserRole.AldManager) && props.vehicleAssessment && (
				<SidebarGroup>
					<SidebarButton
						label="Manuelle DAT Bewertung"
						onClick={() => setManualDatDialogOpen(true)}
						disabled={!!props.vehicleAssessment?.market1Price && !!props.vehicleAssessment?.market2Price}
					/>
				</SidebarGroup>
			)}
			{manualDatDialogOpen && props.vehicleAssessment && (
				<ManualDatValuationDialog
					open={manualDatDialogOpen}
					assessmentId={props.vehicleAssessment.id}
					initialMarket1Price={props.vehicleAssessment.market1Price}
					initialMarket2Price={props.vehicleAssessment.market2Price}
					onClose={() => setManualDatDialogOpen(false)}
					onSaved={(updated) => {
						props.setVehicleAssessment(updated);
						setManualDatDialogOpen(false);
					}}
				/>
			)}
		</Sidebar>
	);
};

export default AssessmentPageSidebar;
